import BaseMapper from '../../BaseMapper';

const SpecifierDescriptionMapper = (data, context) => {
    return data;
};

export default SpecifierDescriptionMapper;
